module.exports = __webpack_public_path__ + "static/sobre_empaques-f998b0ea66e8e87f53a9512ed8438ede.png";